// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

// The accountant's own screen for one task (`FR-10`, user ruling 2026-08-13).
//
// The conversation's strings are NOT here: `TaskConversationThread.vue` is
// mounted by this screen and by the client's portal task, so its catalogue lives
// under `shared/tasks` where one thread cannot be worded two ways.

export default {
    'practiceManagement.task.untitled': 'Task',
    'practiceManagement.task.backToEngagement': 'Back to client',

    'practiceManagement.task.loading': 'Loading this task…',
    'practiceManagement.task.error': 'We could not load this task. Try again.',
    'practiceManagement.task.retry': 'Try again',
    'practiceManagement.task.denied': 'You do not have access to this task.',
    // An archived task and one belonging to another practice are the same 404,
    // so they are the same sentence: telling them apart would undo the reason
    // the server answers them alike.
    'practiceManagement.task.notFound': 'This task could not be found. It may have been archived, or the link you followed may be out of date.',

    'practiceManagement.task.questionsHeading': 'Questions and answers',
    'practiceManagement.task.optionalQuestion': '(optional)',
    'practiceManagement.task.notAnswered': 'Not answered yet',
    'practiceManagement.task.answeredOn': 'Answered {date}',
    'practiceManagement.task.answerYes': 'Yes',
    'practiceManagement.task.answerNo': 'No',

    'practiceManagement.task.documentsHeading': 'Documents received',
};
